import React from 'react';

export default React.createContext({
  locations: [],
  openBox: false,
  setOpenBox: null,
  raio: 1,
  setRaio: null,
  setShowResultados: null,
  showResumoResultados: false,
  search: {
    raio: '1',
    estabelechiment: '',
    lat: '',
    lon: '',
    produto: '',
    referencePoint: '',
  },
  setSearch: null,
  findEstablishment: null,
  empresaSelecionada: {},
  setEmpresaSelecionada: null,
  fullBox: false,
  setFullBox: null,
  companyName: '',
});
